import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import SearchBooks from '@/components/screens/search/search-books/SearchBooks';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { API_URL, BOOKS_FOR_PAGE } from '@/helpers/variables';

interface IBookSearchPageDynamic {
  books: IBookPage;
  totalAlias: string;
  freeBooks: boolean;
}

const BookSearchPageDynamic: NextPage<IBookSearchPageDynamic> = ({ books, totalAlias, freeBooks }) => {
  return <SearchBooks books={books} totalAlias={totalAlias} type="books" freeBooks={freeBooks} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { totalAlias, free_books, page } = context.query;

  const [booksRes] = await Promise.all([fetch(`${API_URL}satellite/books?book_type=book&search_text=${totalAlias}&${!!free_books ? `free_book=true&` : ``}page=${page ? page : `1`}&page_size=${BOOKS_FOR_PAGE}`)]);

  const [books] = await Promise.all([booksRes.json()]);
  const freeBooks = !!free_books;

  return {
    props: {
      books,
      totalAlias,

      freeBooks,
    },
  };
};

export default BookSearchPageDynamic;
